import PricingStatusChangeItem from '../../../../Domain/PricingStatusChangeItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';

// Drives the GeneralEditWizzardBaseFigma status-change action panel for a pricing record.
// Not entity CRUD, so entityName is omitted and the plain 'Update' title wins. Two visible
// fields keep it in the compact centered modal. The warning gate is wired via the wizard's
// approveBeforeSaveCheck / approveBeforeSaveMessage props (see PricingItemDetails.js).
class PricingStatusChangeWindowDescription {
  static titleForCreate = 'Update';
  static titleForEdit = 'Update';
  static finishButtonLabel = 'Save';
  static itemType = PricingStatusChangeItem;
  static serviceFunction = PricingService.StatusChange;
  static messageOnSuccess = 'Pricing status has been changed!';
  static warningMessage =
    "This service already has an 'Approved' pricing record in this country which will be replaced if you continue.";
  static warningCondition = (item) => {
    return item.Action === '4' && item.ServiceHasApprovedPricingForThisCountry === true;
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          className: 'col-3',
          type: InputTypesEnum.EmptySpace,
        },
        {
          fieldName: 'Action',
          label: 'Action',
          className: 'col-6',
          type: InputTypesEnum.PricingStatusChange,
          validityChecker: ValidityHelper.forRequiredTextField,
          idFilter: 'PricingId',
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default PricingStatusChangeWindowDescription;
